// Swatch links that swap all #MainContent sections on collection pages
// for the corresponding sections from the linked collection.

if (!customElements.get('collection-swatch-link')) {
	class CollectionSwatchLink extends HTMLElement {
		static data = new Map();

		constructor() {
			super();

			// Preload in case the swatch is clicked
			this.addEventListener('mousedown', () => this.fetchPage());
			this.addEventListener('mouseenter', () => this.fetchPage());

			this.addEventListener('click', e => {
				e.preventDefault();
				this.swap();
			});
		}

		connectedCallback() {
			if (!this.hasAttribute('active')) return;

			// Centre the active swatch in the carousel
			requestAnimationFrame(() => {
				const container = this.closest('.sbc__swatches');
				if (!container || container.scrollWidth <= container.clientWidth) return;

				const containerRect = container.getBoundingClientRect();
				const rect = this.getBoundingClientRect();
				container.scrollLeft += rect.left + rect.width / 2 - (containerRect.left + containerRect.width / 2);
			});
		}

		get url() {
			return new URL(this.getAttribute('link') || window.location.pathname, window.location.href);
		}

		fetchPage() {
			const key = this.url.pathname + this.url.search;
			if (!CollectionSwatchLink.data.has(key)) {
				CollectionSwatchLink.data.set(key, fetch(key).then(resp => resp.text()));
			}
			return CollectionSwatchLink.data.get(key);
		}

		async swap() {
			const url = this.url;
			const fullUrl = url.pathname + url.search;

			if (fullUrl === window.location.pathname + window.location.search) {
				this.setAttribute('active', '');
				return;
			}

			const html = await this.fetchPage();

			history.replaceState({}, '', fullUrl);

			let template = document.createElement('template');
			template.innerHTML = html;

			const doc = template.content;

			const newTitle = doc.querySelector('title');
			if (newTitle) document.title = newTitle.textContent;

			// Update canonical URL
			const canonical = document.querySelector('link[rel="canonical"]');
			if (canonical) canonical.href = window.location.origin + url.pathname;

			// Maintain scroll position across the swap
			const scrollY = window.scrollY;

			// Reload all sections within #MainContent
			const mainContent = document.getElementById('MainContent');
			const existingSections = [...mainContent.children].filter(el => el.classList.contains('shopify-section'));
			const newSections = [...doc.querySelectorAll('.shopify-section')].filter(section => section.parentElement == doc.getElementById('MainContent'));

			existingSections.forEach((section, i) => {
				const newSection = doc.getElementById(section.id) || newSections[i];
				if (newSection) section.replaceWith(newSection);
			});

			window.scrollTo(0, scrollY);
		}
	}

	customElements.define('collection-swatch-link', CollectionSwatchLink);
}
